export default __webpack_public_path__ + "static/staff001-3002a44d7fa597a6f105a3aa98887fe8.png";